/**
 * Logical Reasoning Test (LRT) — simplified (10 items).
 * Question images: client/public/asset/images/ability-test/LRT/
 *
 * Answer keys were not supplied — scoreTable entries are 0 until analysts set correct options.
 */
import { lrtQuestionImageUrl } from './abilityTestImages.js';

const L = (en, tc, sc) => ({
  en,
  tc: tc != null ? tc : en,
  sc: sc != null ? sc : en
});

const OPT_5 = [
  ['A', L('Option A', '選項 A', '选项 A')],
  ['B', L('Option B', '選項 B', '选项 B')],
  ['C', L('Option C', '選項 C', '选项 C')],
  ['D', L('Option D', '選項 D', '选项 D')],
  ['E', L('Option E', '選項 E', '选项 E')]
];

function scorePending(keys) {
  const table = {};
  for (const k of keys) table[k] = 0;
  return table;
}

/**
 * @param {number} displayNumber
 * @param {{en:string,tc:string,sc:string}} prompt
 * @param {[string, {en:string,tc:string,sc:string}][]} optionRows
 */
function lrtQuestion(displayNumber, prompt, optionRows) {
  const keys = optionRows.map(([key]) => key);
  return {
    id: `lrt-q${displayNumber}`,
    displayNumber,
    imageUrl: lrtQuestionImageUrl(displayNumber),
    prompt,
    options: optionRows.map(([key, label]) => ({ key, label })),
    scoreTable: scorePending(keys)
  };
}

function section(id, titleEn, titleTc, titleSc, questions) {
  return {
    id,
    title: L(titleEn, titleTc, titleSc),
    passages: [],
    questions
  };
}

const SEQ_NEXT = L(
  'What comes next in the sequence?',
  '以下序列的下一項是甚麼？',
  '以下序列的下一项是什么？'
);

const TO_WHICH_SET = L(
  'To which set does the figure belong?',
  '該圖形屬於哪一個集合？',
  '该图形属于哪一个集合？'
);

const MISSING_PART_TOP_BOTTOM = L(
  'The sequence consists of the top and bottom square. Which of the answers below matches the missing part of this sequence?',
  '此序列由上、下兩個方格組成。以下哪個選項最符合該序列缺失的部分？',
  '此序列由上、下两个方格组成。以下哪个选项最符合该序列缺失的部分？'
);

const MISSING_PART = L(
  'Which of the answers below matches the missing part of this sequence?',
  '以下哪個選項最符合該序列缺失的部分？',
  '以下哪个选项最符合该序列缺失的部分？'
);

export const logicalReasoningTestPaper = {
  slug: 'logical-reasoning',
  title: L('Logical Reasoning', '邏輯推理', '逻辑推理'),
  paperInstruction: L(
    'Each question shows a pattern or diagram in the image. Select the single best answer.',
    '每題附圖展示圖案或規律，請選出唯一最佳答案。',
    '每题附图展示图案或规律，请选出唯一最佳答案。'
  ),
  timeLimitSeconds: 3600,
  order: 0,
  isPublished: true,
  sections: [
    section(
      'lrt-simplified',
      'Visual reasoning',
      '案例：圖像推理',
      '案例：图像推理',
      [
      lrtQuestion(1, SEQ_NEXT, OPT_5),
      lrtQuestion(2, SEQ_NEXT, OPT_5),
      lrtQuestion(3, SEQ_NEXT, OPT_5),
      lrtQuestion(4, SEQ_NEXT, OPT_5),
      lrtQuestion(5, SEQ_NEXT, OPT_5),
      lrtQuestion(6, SEQ_NEXT, OPT_5),
      lrtQuestion(7, TO_WHICH_SET, OPT_5),
      lrtQuestion(8, MISSING_PART_TOP_BOTTOM, OPT_5),
      lrtQuestion(9, MISSING_PART, OPT_5),
      lrtQuestion(10, MISSING_PART_TOP_BOTTOM, OPT_5)
    ])
  ]
};

